"use client";
import { useState } from "react";

const ProductDisplay = ({ visuals,product }) => {
  const [list, setList] = useState(visuals);
  
  // Function replace to 
  const replace = (i,el) =>{
    setList(list.map((element,j)=>j==i? list[4]:j==4? el:element))
  }
  return (
    <div className="w-full flex h-full flex-col gap-6 lg:flex-row">
      <div className="w-full lg:w-[20%] flex flex-row lg:flex-col items-center justify-around order-2 lg:order-1 overflow-x-scroll lg:overflow-x-auto gap-2 lg:gap-0">
        {list.map((el, i) => {
          return el[0] && i < 4 && el[1] ? (
            <img
            key={i}
              src={el[1]}
              width={330}
              height={330}
              className="w-[108px] h-[108px] rounded-[27px] bg-[#4A4A4A] lg:bg-transparent lg:rounded-none lg:h-[30px] lg:w-[60%] object-contain cursor-pointer"
              alt="product-Img"
              onClick={
                  ()=>replace(i,el)
              }
            />
          ) : null;
        })}
      </div>
      <div className="w-full lg:w-[80%] lg:h-full  flex justify-center items-center order-1 lg:order-2">
        {list[4][0] ? (
          <img
            src={list[4][1]}
            width={330}
            height={330}
            className="h-[125px] lg:h-[80%] w-[125px] lg:w-[80%] object-contain"
            alt="product-Img"
          />
        ) : null}
        <div className="w-[55%] lg:hidden">
          <h2 className="text-xs font-medium">{product?.brand}</h2>
          <h1 className="text-[15px] font-medium">{product?.name}</h1>
        </div>
      </div>
    </div>
  );
};

export default ProductDisplay;
